<script setup>
import { ref } from 'vue'

const email = ref('')
const loading = ref(false)
const success = ref(false)
const error = ref('')

const submitForm = async (e) => {
  e.preventDefault()
  loading.value = true
  error.value = ''

  try {
    const response = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        access_key: 'b717d305-80a8-41fc-9fd0-b4eed2842f0d', // User needs to replace this
        email: email.value,
        subject: 'New Kannister Waitlist Signup',
        from_name: 'Kannister Website'
      })
    })

    const data = await response.json()

    if (data.success) {
      success.value = true
      email.value = ''
    } else {
      error.value = 'Something went wrong. Please try again.'
    }
  } catch (err) {
    error.value = 'Network error. Please try again.'
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <section id="waitlist" class="py-20 bg-gradient-to-br from-kannister-blue-600 to-kannister-blue-800">
    <div class="section-container">
      <div class="max-w-2xl mx-auto text-center">
        <!-- Section Header -->
        <h2 class="text-4xl md:text-5xl font-bold text-white mb-4">
          Join the Waitlist
        </h2>
        <p class="text-xl text-kannister-blue-100 mb-8">
          Get early access to Kannister. Be the first to secure your development environments.
        </p>

        <!-- Success Message -->
        <div
          v-if="success"
          class="bg-green-500 text-white px-6 py-4 rounded-lg mb-8 flex items-center justify-center space-x-2"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          <span class="font-medium">Thanks! You're on the waitlist. Check your email for confirmation.</span>
        </div>

        <!-- Form -->
        <form v-else @submit="submitForm" class="flex flex-col sm:flex-row gap-4">
          <!-- Honeypot for spam prevention -->
          <input type="checkbox" name="botcheck" class="hidden" style="display: none;">

          <input
            v-model="email"
            type="email"
            required
            placeholder="Enter your email"
            class="flex-1 px-6 py-4 rounded-lg text-kannister-dark-900 placeholder-kannister-dark-400 focus:outline-none focus:ring-2 focus:ring-white"
          />
          <button
            type="submit"
            :disabled="loading"
            class="bg-white text-kannister-blue-600 font-bold px-8 py-4 rounded-lg hover:bg-kannister-dark-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {{ loading ? 'Submitting...' : 'Join Waitlist' }}
          </button>
        </form>

        <!-- Error Message -->
        <div
          v-if="error"
          class="mt-4 text-red-300 text-sm"
        >
          {{ error }}
        </div>

        <!-- Privacy Notice -->
        <p class="mt-6 text-sm text-kannister-blue-200">
          We'll never share your email. Unsubscribe anytime.
        </p>
      </div>
    </div>
  </section>
</template>
